import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';


const NO_WHITESPACE_PATTERN = /^\s*$/;

@Directive({
    selector: '[jhiWhitespace][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: WhiteSpaceValidatorDirective, multi: true }
    ]
})
export class WhiteSpaceValidatorDirective implements Validator {

    constructor() {}

    validate(c: AbstractControl): ValidationErrors {

        if (c.value && NO_WHITESPACE_PATTERN.test(c.value)) {
            return { 'invalid-whitespace': true };
        }
        return null;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/validators/whitespace-validator.ts